import { SHA3 } from 'sha3';
import api from './api';

export async function registerAccount(username, password, email, captcha) {
  const response = await api.post('/register', {
    u: username,
    p: new SHA3(256).update(password).digest('hex'),
    e: email,
    c: captcha,
  });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function checkUsernameTaken(username) {
  const response = await api.get(`/checkAccountExistence/${username}`);
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
